import * as types from '@/store/mutationTypes';
import API from '@/api';

const state = {
  asset: {},
};

const getters = {
  asset: state => state.asset,
  assetType: state => state.asset.type,
  assetUrl: state => state.asset.url,
};

const mutations = {
  [types.SET_LIGHTBOX_ASSET](state, asset) {
    
    // eslint-disable-next-line no-param-reassign
    state.asset = asset;
  },
};

const actions = {

  async show({ commit }, url) {
    commit(`applications/${types.START_LOADING}`,null, {root: true});
    try {
      const response = await API.application.getDocument({ url });
      const assetUrl = window.URL.createObjectURL(response);
      commit(types.SET_LIGHTBOX_ASSET, {url:assetUrl, type:response.type});
    } catch(error) {
      console.error(error)
    }
    
    commit(`applications/${types.END_LOADING}`,null, {root: true});
    },
  
  async dismiss({ commit }) {
    commit(types.SET_LIGHTBOX_ASSET, {});
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/lightbox.js